import { render, staticRenderFns } from "./pc-header.vue?vue&type=template&id=2435ee1c&scoped=true&lang=pug&"
import script from "./pc-header.vue?vue&type=script&lang=js&"
export * from "./pc-header.vue?vue&type=script&lang=js&"
import style0 from "./pc-header.vue?vue&type=style&index=0&id=2435ee1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435ee1c",
  null
  
)

export default component.exports